import { PageHeader } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { buildCreateRevshopSkuMarkupParam } from 'domains/markupDomain';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SkuMarkupItemForm from './SkuMarkupItemForm';
import SkuMarkupTable from './SkuMarkupTable';

const RevshopSkuMarkupTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.markup.curSkuMarkup);

  return (
    <>
      <PageHeader
        ghost={false}
        extra={[
          <RevxButton
            key="create"
            type="primary"
            onClick={() => {
              dispatch.markup.saveMarkup(buildCreateRevshopSkuMarkupParam());
            }}
          >
            {t('platform.markup.titles.create')}
          </RevxButton>,
        ]}
      />

      {curItem && <SkuMarkupItemForm />}
      <SkuMarkupTable />
    </>
  );
};

export default RevshopSkuMarkupTab;
